import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

const Pagination = ({ url, itemsPerPage, totalItems, currentPage, onPageChange }) => {

    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const [showPrevious, setShowPrevious] = useState(currentPage > 1);
    const [showNext, setShowNext] = useState(currentPage < totalPages);
    let navigate = useNavigate();
    const handlePageClick = (pageNumber) => {
   
        navigate(url + '?page=' + pageNumber,{state:{refresh:true}});
        navigate(0);

    };


    const renderPageNumbers = () => {
        const pageNumbers = [];
        const range = 2;

        // Add the first page
        pageNumbers.push(
            <li key={1} className={`page-item ${currentPage == 1 && "active"}`}>
                <button className="page-link" onClick={() => handlePageClick(1)}>
                    1
                </button>
            </li>
        );

        // Add ellipsis if not on the first few pages
        if (currentPage > range + 2) {
            pageNumbers.push(
                <li key="startEllipsis" className="page-item disabled">
                    <span className="page-link">...</span>
                </li>
            );
        }

        // Add the page numbers before and after the current page
        for (let i = currentPage - range; i <= currentPage + range; i++) {
            if (i > 1 && i <= totalPages) {
                pageNumbers.push(
                    <li key={i} className={`page-item ${currentPage == i && "active"}`}>
                        <button className="page-link" onClick={() => handlePageClick(i)}>
                            {i}
                        </button>
                    </li>
                );
            }
        }

        // Add ellipsis if not on the last few pages
        if (currentPage < totalPages - range - 1) {
            pageNumbers.push(
                <li key="endEllipsis" className="page-item disabled">
                    <span className="page-link">...</span>
                </li>
            );
        }

        // Add the last page
        if (totalPages > 1) {
            pageNumbers.push(
                <li key={totalPages} className={`page-item ${currentPage === totalPages && "active"}`}>
                    <button className="page-link" onClick={() => handlePageClick(totalPages)}>
                        {totalPages}
                    </button>
                </li>
            );
        }

        return pageNumbers;
    };

    return (
        <nav>
            <ul className="pagination">
                {showPrevious && (
                    <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                        <button className="page-link" onClick={() => handlePageClick(currentPage - 1)}>
                            <i class="fa fa-angle-double-left"></i>
                        </button>
                    </li>
                )}
                {renderPageNumbers()}
                {showNext && (
                    <li className={`page-item ${currentPage === totalPages && "disabled"}`}>
                        <button className="page-link" onClick={() => handlePageClick(currentPage + 1)}>
                            <i class="fa fa-angle-double-right"></i>
                        </button>
                    </li>
                )}
            </ul>
        </nav>
    );
}

export default Pagination;
